import { TRACKERS } from "@/constants/Trackers";
import { Immunizations } from "@/features/Patient/MedicalRecords/Immunization/Immunizations";
import { trackEvent } from "@/lib/tracking";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/patient/$patientId/immunizations")({
  component: RouteComponent,
  onEnter: async () => {
    trackEvent(TRACKERS.IMMUNIZATIONS);
  },
});

function RouteComponent() {
  return <Immunizations />;
}
